import { ValueObject } from "@singularsystems/neo-core";

export default class ProcessBatchCommand extends ValueObject{
  batchId: number = 0;
  staticServiceProviderId: number = 0;
}